import { useState } from 'react';
import { DialogTitle } from '@savvy-kit/components/dialog';
import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';
import { toast } from 'sonner';
import TrackedDialog from 'src/components/tracked/tracked-dialog';

import type { AddAccountItemType } from './constants';
import { CLIENT_PORTAL_DIALOG_PANEL_CLASS } from '../common/constants';
import { AccountsAddAccountPicker } from './accounts-add-account-picker';
import { AddAccountFlow } from './add-account/add-account-flow';
import { ADD_ACCOUNT_DIALOG_TITLE, ADD_ACCOUNT_LINKED_TOAST, ADD_ACCOUNT_PICKER_HEADING } from './constants';

type AccountsAddAccountDialogProps = {
  readonly initialItemType?: AddAccountItemType;
  readonly feedOnly?: boolean;
  readonly onLinked: () => Promise<unknown>;
  readonly onClose: () => void;
};

export function AccountsAddAccountDialog({
  initialItemType,
  feedOnly,
  onLinked,
  onClose,
}: AccountsAddAccountDialogProps) {
  const [itemType, setItemType] = useState(initialItemType);
  const [writeLanded, setWriteLanded] = useState(false);
  const startedAtPicker = isNil(initialItemType);

  const confirmLinked = () => {
    toast.success(ADD_ACCOUNT_LINKED_TOAST);
    return onLinked();
  };

  return (
    <TrackedDialog
      elementName="add-item-dialog"
      open
      onOpenChange={(nextOpen) => {
        if (nextOpen) {
          return;
        }
        if (writeLanded) {
          void confirmLinked();
          return;
        }
        onClose();
      }}
      className={CLIENT_PORTAL_DIALOG_PANEL_CLASS}
    >
      <DialogTitle className={cn(isNil(itemType) ? 'shrink-0 px-6 pt-6 pb-4' : 'sr-only')}>
        {isNil(itemType) ? ADD_ACCOUNT_PICKER_HEADING : ADD_ACCOUNT_DIALOG_TITLE}
      </DialogTitle>
      {isNil(itemType) && (
        <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-6">
          <AccountsAddAccountPicker onSelect={setItemType} />
        </div>
      )}
      {!isNil(itemType) && (
        <AddAccountFlow
          itemType={itemType}
          feedOnly={feedOnly}
          onWriteLanded={() => {
            setWriteLanded(true);
          }}
          onCancel={
            startedAtPicker
              ? () => {
                  setItemType(undefined);
                }
              : onClose
          }
          onLinked={confirmLinked}
        />
      )}
    </TrackedDialog>
  );
}
